/* eslint-disable */
import React from "react";
import { CgMenuRightAlt, CgClose } from "react-icons/cg";
import { Link } from "react-router-dom";

function Header() {
  function openNav() {
    document.getElementById("openNav").classList.add("close");
    document.getElementById("openNav").classList.remove("open");
    document.getElementById("closeNav").classList.add("open");
    document.getElementById("closeNav").classList.remove("close");
    document.getElementById("headerNav").classList.add("open");
    document.getElementById("topHead").classList.add("change");
  }
  function closeNav() {
    document.getElementById("closeNav").classList.remove("open");
    document.getElementById("closeNav").classList.add("close");
    document.getElementById("openNav").classList.remove("close");
    document.getElementById("openNav").classList.add("open");
    document.getElementById("headerNav").classList.remove("open");
    document.getElementById("topHead").classList.remove("change");
  }

  function fiction() {
    document.getElementById("fiction").classList.add("active");
    document.getElementById("fiction").classList.add("show");
    document.getElementById("fictionArea").classList.add("active");
    document.getElementById("fictionArea").classList.add("show");
    document.getElementById("nonFiction").classList.remove("active");
    document.getElementById("nonFiction").classList.remove("show");
    document.getElementById("non-fictionArea").classList.remove("active");
    document.getElementById("non-fictionArea").classList.remove("show");
    document.getElementById("topHead").classList.remove("change");
    document.getElementById("openNav").classList.add("open");
    document.getElementById("openNav").classList.remove("close");
    document.getElementById("closeNav").classList.add("close");
    document.getElementById("closeNav").classList.remove("open");
    document.getElementById("headerNav").classList.remove("open");
  }
  function nonFiction() {
    document.getElementById("nonFiction").classList.add("active");
    document.getElementById("nonFiction").classList.add("show");
    document.getElementById("non-fictionArea").classList.add("active");
    document.getElementById("non-fictionArea").classList.add("show");
    document.getElementById("fiction").classList.remove("active");
    document.getElementById("fiction").classList.remove("show");
    document.getElementById("fictionArea").classList.remove("active");
    document.getElementById("fictionArea").classList.remove("show");
    document.getElementById("topHead").classList.remove("change");
    document.getElementById("openNav").classList.add("open");
    document.getElementById("openNav").classList.remove("close");
    document.getElementById("closeNav").classList.add("close");
    document.getElementById("closeNav").classList.remove("open");
    document.getElementById("headerNav").classList.remove("open");
  }

  function articles() {
    document.getElementById("articles").classList.add("active");
    document.getElementById("articles").classList.add("show");
    document.getElementById("articlesArea").classList.add("active");
    document.getElementById("articlesArea").classList.add("show");
    document.getElementById("opEds").classList.remove("active");
    document.getElementById("opEds").classList.remove("show");
    document.getElementById("op-edsArea").classList.remove("active");
    document.getElementById("op-edsArea").classList.remove("show");
    document.getElementById("topHead").classList.remove("change");
    document.getElementById("openNav").classList.add("open");
    document.getElementById("openNav").classList.remove("close");
    document.getElementById("closeNav").classList.add("close");
    document.getElementById("closeNav").classList.remove("open");
    document.getElementById("headerNav").classList.remove("open");
  }
  function opEds() {
    document.getElementById("opEds").classList.add("active");
    document.getElementById("opEds").classList.add("show");
    document.getElementById("op-edsArea").classList.add("active");
    document.getElementById("op-edsArea").classList.add("show");
    document.getElementById("articles").classList.remove("active");
    document.getElementById("articles").classList.remove("show");
    document.getElementById("articlesArea").classList.remove("active");
    document.getElementById("articlesArea").classList.remove("show");
    document.getElementById("topHead").classList.remove("change");
    document.getElementById("openNav").classList.add("open");
    document.getElementById("openNav").classList.remove("close");
    document.getElementById("closeNav").classList.add("close");
    document.getElementById("closeNav").classList.remove("open");
    document.getElementById("headerNav").classList.remove("open");
  }
  function closeMobileMenu() {
    document.getElementById("topHead").classList.remove("change");
    document.getElementById("openNav").classList.add("open");
    document.getElementById("openNav").classList.remove("close");
    document.getElementById("closeNav").classList.add("close");
    document.getElementById("closeNav").classList.remove("open");
    document.getElementById("headerNav").classList.remove("open");
  }

  return (
    <>
      <div className="fixedNav">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div id="navbar" className="mainHeader">
                <div className="mobileMenuBtn">
                  <CgMenuRightAlt
                    id="openNav"
                    className="open"
                    onClick={() => openNav()}
                  />
                  <CgClose
                    id="closeNav"
                    className="close"
                    onClick={() => closeNav()}
                  />
                </div>
                <div id="headerNav" className="headerNav">
                  <Link to={"/"} className="name">
                    <span className="bannerTitle">Evan</span>
                    <h1 className="bannerTitle">Mandery</h1>
                  </Link>
                  <ul>
                    <li>
                      <a
                        className="active"
                        href={"/"}
                        onClick={() => closeMobileMenu()}
                      >
                        Home
                      </a>
                    </li>
                    <li>
                      <a href={"/#poison"} onClick={() => closeMobileMenu()}>
                        Poison Ivy
                      </a>
                    </li>
                    <li className="bookDropdown position-relative">
                      <a className="iconChange position-relative">Upcoming</a>
                      <div className="dropdownMenu text-center position-absolute">
                        <Link to={"/event"} className="singleItem">
                          Events
                        </Link>
                        <hr />
                        <Link className="singleItem" to={"/news"}>
                          News
                        </Link>
                      </div>
                    </li>
                    <li className="bookDropdown position-relative">
                      <a className="iconChange position-relative">Books</a>
                      <div className="dropdownMenu text-center position-absolute">
                        <a
                          className="singleItem"
                          href={"/#fictionArea"}
                          onClick={() => fiction()}
                        >
                          Fiction
                        </a>
                        <hr />
                        <a
                          className="singleItem"
                          href={"/#non-fictionArea"}
                          onClick={() => nonFiction()}
                        >
                          Non-Fiction
                        </a>
                      </div>
                    </li>

                    <li>
                      <a href={"/#research"} onClick={() => closeMobileMenu()}>
                        Research
                      </a>
                    </li>
                    <li className="bookDropdown position-relative">
                      <a className="iconChange position-relative">Journalism</a>
                      <div className="dropdownMenu text-center position-absolute">
                        <a
                          className="singleItem"
                          href={"/#articlesArea"}
                          onClick={() => articles()}
                        >
                          Articles
                        </a>
                        <hr />
                        <a
                          className="singleItem"
                          href={"/#op-edsArea"}
                          onClick={() => opEds()}
                        >
                          Op-Eds
                        </a>
                      </div>
                    </li>
                    <li>
                      <a
                        href={"/#fotterArea"}
                        onClick={() => closeMobileMenu()}
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
